<script setup lang="ts">
import { ref, watch } from 'vue'
import { set } from 'lodash'
import InputNumber from 'primevue/inputnumber'

const props = defineProps<{
    form: any
    fieldName: string
    options?: any
    fieldData?: {
        label?: string
        placeholder?: string
        required?: boolean
        readonly?: boolean
    }
}>()

const emits = defineEmits()

const getValue = () => {
    if (Array.isArray(props.fieldName)) {
        return props.fieldName.reduce((acc: any, key: string) => acc?.[key], props.form) ?? null
    }
    return props.form[props.fieldName] ?? null
}

const value = ref<number | null>(getValue())

watch(value, (newValue) => {
    if (Array.isArray(props.fieldName)) {
        set(props.form, props.fieldName, newValue)
    } else {
        props.form[props.fieldName] = newValue
    }
    props.form.errors[props.fieldName] = ''
    emits('update:form', props.form)
})
</script>

<template>
    <div>
        <InputNumber
            :modelValue="value"
            @input="(e) => value = e.value "
            mode="currency"
            currency="IDR"
            locale="id-ID"
            :minFractionDigits="0"
            :maxFractionDigits="0"
            :placeholder="fieldData?.placeholder ?? '0'"
            :disabled="fieldData?.readonly"
            :invalid="!!form.errors[fieldName]"
            fluid
            class="w-full"
        />
        <p v-if="form.errors[fieldName]" class="mt-1 text-sm text-red-600">{{ form.errors[fieldName] }}</p>
    </div>
</template>
